import { useEffect, useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { NavigationDataProps } from 'types/types';
import { constructSearchQueryFromFilters, getOptionsForLevel } from '../../utils/helpers';
import { t } from '../../utils/resources';
import { smoothScroll, saveDashboardFiltersUserChoice } from './helper';
import './DashboardWidescreens.less';

export const DashboardWidescreens = ({ filters, filterNames }: NavigationDataProps) => {
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [selectedFilterOptions, setSelectedFilterOptions] = useState<any>({});
  const [filtersData, setFiltersData] = useState<any>();

  const getOptions = useCallback(
    (level: number): string[] => {
      const options = getOptionsForLevel(level, filters, filterNames, selectedFilters, false);

      return options && options.length > 0 ? options.map((opt: any) => opt.text) : [];
    },
    [filterNames, filters, selectedFilters]
  );

  const handleMenuOptionClick =
    (selectedOption: string, filter: string, filterNameIndex: number) => () => {
      setSelectedFilterOptions({
        ...selectedFilterOptions,
        [filter]: !selectedFilterOptions[filter] ? selectedOption : '',
      });

      if (filterNameIndex !== filterNames.length - 1 && !selectedFilterOptions[filter]) {
        smoothScroll(`${filter.replace(' ', '')}-set`);
      }
    };

  const handlePillsClick =
    (selectedOption: string, filter: string, filterNameIndex: number) => () => {
      setSelectedFilterOptions({
        ...selectedFilterOptions,
        [filter]: !selectedFilterOptions[filter] ? selectedOption : '',
      });

      if (filterNameIndex > 0 && !selectedFilterOptions[filter]) {
        smoothScroll(`${filter.replace(' ', '')}-set`);
      }
    };

  useEffect(() => {
    let newFilters = {};

    if (filterNames.length > 0) {
      filterNames.forEach((filter, idx) => {
        newFilters = { ...newFilters, [filter]: getOptions(idx) };
      });
    }
    setFiltersData(newFilters);
  }, [filterNames, getOptions]);

  useEffect(() => {
    const optedFilters: string[] = [];

    Object.keys(selectedFilterOptions).forEach((key) => {
      optedFilters.push(selectedFilterOptions[key]);
    });

    setSelectedFilters(optedFilters);

    if (selectedFilterOptions && selectedFilterOptions[filterNames[filterNames.length - 1]]) {
      const newSearchQuery = constructSearchQueryFromFilters(optedFilters);
      localStorage.setItem('initial-dashboard-filters', newSearchQuery);
      window.location.href = '/?' + newSearchQuery;
    }
  }, [filterNames, selectedFilterOptions]);

  return (
    <>
      <div className="dashboard-sections">
        {filterNames &&
          filterNames.length > 0 &&
          filterNames.map((filter, filterNameIndex) => (
            <div
              key={`filter-${uuidv4()}`}
              className={`section ${filter.replace(' ', '').toLowerCase().trim()}-section`}
              id={`${filter.replace(' ', '')}-set`}
            >
              <h5 className="section-title">{filter.toString().toUpperCase()}</h5>
              {filterNameIndex > 1 ? (
                <ul>
                  {filtersData &&
                    filtersData[filter] &&
                    filtersData[filter].map((option: string) => {
                      return (
                        <li
                          key={`menu-option-${uuidv4()}`}
                          className={`menu-option ${
                            selectedFilterOptions[filter] === option ? 'active' : ''
                          }`}
                          onClick={handleMenuOptionClick(option, filter, filterNameIndex)}
                        >
                          <span className="menu-text">{option}</span>
                        </li>
                      );
                    })}
                </ul>
              ) : (
                <ul>
                  {filtersData &&
                    filtersData[filter] &&
                    filtersData[filter].map((option: string) => {
                      return (
                        <li
                          key={`pills-option-${uuidv4()}`}
                          className={`pills-bg ${
                            selectedFilterOptions[filter] === option ? 'active' : ''
                          }`}
                          onClick={handlePillsClick(option, filter, filterNameIndex)}
                        >
                          <span className="pills-text">{option}</span>
                        </li>
                      );
                    })}
                </ul>
              )}
            </div>
          ))}
      </div>
      {/* Footer User Choice */}
      <div className="footer-userchoice">
        <label>
          <input type="checkbox" onClick={(event: any) => saveDashboardFiltersUserChoice(event)} />
          {t('Dashboard.UserChoiceText')}
        </label>
      </div>
    </>
  );
};
